import React from 'react';
import styled from 'styled-components';
import { CSSProperties } from 'react';

export const Arrow = styled.div`
	align-self: center;
	border-left: 5px solid transparent;
	border-right: 5px solid transparent;
	border-top: 6px solid;
	display: inline-block;
	height: 0;
	margin-left: 5px;
	width: 0;
`;

export const arrowDownIconStyle: CSSProperties = {
	transition: '.3s',
};

export const arrowUpIconStyle: CSSProperties = {
	transform: 'rotateZ(180deg)',
	transition: '.3s',
};

export const getArrows = (isUp: boolean) => (
	<Arrow
		style={isUp ? arrowUpIconStyle : arrowDownIconStyle}
		className={isUp ? 'icon-arrow-up' : 'icon-arrow-down'}
	/>
);
